import React, {forwardRef, Fragment, memo, useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import modClasses from '@mapsight/ui/src/js/helpers/mod-classes';
import {selectExclusively} from '@mapsight/core/lib/feature-selections/actions';
import {FEATURE_SELECTIONS} from '@mapsight/ui/src/js/config/constants/controllers';
import {FEATURE_SELECTION_PRESELECT,} from '@mapsight/ui/src/js/config/feature/selections';

import {useNavPos} from '../../../hooks';

import {createHeartSelector} from '../../store/selectors';
import {setHeart} from '../../store/actions';

import Link from '../link';
import Stars from '../../../ratings/components/stars';


export default memo(forwardRef(
	/** @param {{
	 *   children: React.ReactChildren,
	 *   className: string,
	 *   feature?: import('../../types').Feature,
	 * }} props */
	function ListItem({ children, className, feature, ...other }, ref) {
		const dispatch = useDispatch();
		const navPos = useNavPos();

		const preselectedId = useSelector(state => (state[FEATURE_SELECTIONS][FEATURE_SELECTION_PRESELECT]?.features ?
			state[FEATURE_SELECTIONS][FEATURE_SELECTION_PRESELECT].features[0] :
			null
		));

		const heartSelector = useMemo(
			() => createHeartSelector(navPos?.app?.uri, feature?.id),
			[navPos?.app?.uri, feature?.id]
		);
		const heart = useSelector(heartSelector);
		const onHeartClick = useCallback(
			/** @param {React.MouseEvent} e */
			(e) => {
				dispatch(setHeart(navPos?.app?.uri, feature?.id, !heart?.heart));
			},
			[dispatch, navPos?.app?.uri, feature?.id, heart?.heart]
		);

		const onNameClick = useCallback(
			/** @param {React.MouseEvent} e */
			(e) => {
				dispatch(selectExclusively(
					FEATURE_SELECTIONS,
					FEATURE_SELECTION_PRESELECT,
					feature?.id,
				));
			},
			[dispatch, feature?.id]
		);

		const onPoiClick = useCallback(
			/** @param {React.MouseEvent} e */
			(e) => {
				dispatch(selectExclusively(
					FEATURE_SELECTIONS,
					FEATURE_SELECTION_PRESELECT,
					feature?.id,
				));
			},
			[dispatch, feature?.id]
		);

		// console.log('list-item '+feature?.id, {feature, children, className, other, heart, navPos});
		// TODO Stade: Herzen nur falls kinder → benötigt Eintrag im Backend und dem app-Object in magic

		if (!feature) {
			return (
				<Fragment>
					{children}
				</Fragment>
			);
		}

		return (
			<li
				className={modClasses('stade-list-item', {
					selected: preselectedId && preselectedId === feature?.id,
					'with-heart': navPos.app?.hearts,
					'with-ratings': !navPos.app?.hearts && navPos.withStarsRating
				})}
				ref={ref}
			>
				<div
					className="stade-list-item__name"
					onClick={onNameClick}
				>
					<div className="stade-list-item__name__text">
						{feature?.properties?.name || feature?.id}
					</div>
				</div>

				<div className="stade-list-item__controls">
					{navPos.app?.hearts &&
						<button
							className={modClasses("stade-list-item__heart", {on: heart?.heart || false})}
							onClick={onHeartClick}
						>
							<div className="stade-list-item__heart__image"/>
						</button>
					}
					{!navPos.app?.hearts && navPos.withStarsRating &&
						<Stars feature={feature} short />
					}

					<Link
						className="stade-list-item__poi"
						onClick={onPoiClick}
						to={`${navPos.app?.url}/${navPos.app?.lang === 'en' ? 'map' : 'karte'}`}
					>
						<div className="stade-list-item__poi__image" />
					</Link>

					<Link
						className="stade-list-item__tour"
						to={`${navPos.app?.url}/${feature?.id}`}
					>
						<div className={modClasses('stade-list-item__tour__image', {
								 flag: navPos.listMorePoi || feature?.properties?.name && feature.properties.name.startsWith('poi-')
								// TODO: weitere Icons für alle erlaubnten Arten von zusätzlichen POI zeichnen und hier auswählen
							 })} />
					</Link>
				</div>
			</li>
		);
	}
));
